import { NBSP } from '../../constants/symbols';

export const RENT_DESCRIPTION_TEXT = `Рассчитали, используя объявления похожих квартир, в том числе недавно снятых с${NBSP}аренды и${NBSP}цены сделок.`;
export const RENT_TITLE = 'Оценка арендной ставки';
export const SALE_DESCRIPTION_TEXT = `Рассчитали, используя объявления похожих квартир, в том числе недавно снятых с${NBSP}продажи и цены сделок.`;
export const SALE_TITLE = 'Оценка стоимости квартиры';
export const LINK_TEXT = 'О методе расчета';
export const LAND_DESCRIPTION_TEXT = `Оценку рассчитали, используя объявления похожих участков. Учли участки, снятые с${NBSP}продажи и${NBSP}цены сделок.`;
export const HOUSE_DESCRIPTION_TEXT = `Оценку рассчитали, используя объявления похожих домов. Учли дома, снятые с${NBSP}продажи и${NBSP}цены сделок.`;
export const LAND_TITLE = 'Оценка стоимости участка';
export const HOUSE_TITLE = 'Оценка стоимости дома';
export const FLAT_METHODIC_LINK =
  'https://hc.cian.ru/hc/ru/articles/360032258772-%D0%9C%D0%B5%D1%82%D0%BE%D0%B4%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%8F-%D0%BE%D1%86%D0%B5%D0%BD%D0%BA%D0%B8';
export const SUBURBAN_METHODIC_LINK = 'https://support.cian.ru/ru/knowledge_base/art/307/cat/89/';
